import get from "lodash/get";
import axios from "axios";
import { ProgramData } from "../context/program";

const createAxios = () => {
  return axios.create({
    baseURL: process.env.REACT_APP_LB_BE_API_ENDPOINT,
  });
};

export const getProductDetail = async (
  access_token: string,
  item_id: string
) => {
  const response = await createAxios().post("api/base-shop/item-detail", {
    access_token,
    item_id,
  });
  return get(response, "data.item", "");
};

export const getProductInfoBaseShop = async (
  accessToken: string,
  programProducts: ProgramData[]
) => {
  const productId =
    get(programProducts[0], "product.productUrl", "").split("/").pop() || "";
  const productSize = get(programProducts[0], "product.productSize", "");
  const productInfo = await getProductDetail(accessToken, productId);
  const variationProduct = productInfo?.variations
    ? productInfo?.variations?.find(
        // eslint-disable-next-line
        (item: any) => item.variation === productSize.toUpperCase()
      )
    : null;
  return {
    itemTaxType: productInfo?.item_tax_type,
    variationId: variationProduct?.variation_id,
    variationName: variationProduct?.variation,
  };
};

export const getAccessToken = async (
  client_id: string,
  client_secret: string,
  access_token: string,
  refresh_token: string,
  redirect_uri: string
) => {
  const response = await createAxios().post(
    "api/base-shop/auth/refresh-token",
    {
      client_id,
      client_secret,
      access_token,
      refresh_token,
      redirect_uri,
    }
  );
  const accessToken = get(response, "data.access_token", "");
  const refreshToken = get(response, "data.refresh_token", "");
  return { accessToken, refreshToken };
};
